import React from "react";

export interface CompanyInfo {
  phone?: string;
  email?: string;
  address?: {
    line1?: string;
    line2?: string;
  };
  social?: {
    whatsapp?: string;
    instagram?: string;
    facebook?: string;
    linkedin?: string;
  };
  workingHours?: string;
}

/**
 * Loads company info from a static JSON served from /public.
 * Consumers use optional chaining, so returning null on error is fine.
 */
const useCompany = (): CompanyInfo | null => {
  const [company, setCompany] = React.useState<CompanyInfo | null>(null);

  React.useEffect(() => {
    let isMounted = true;
    fetch("/data/company/index.json", { cache: "no-store" })
      .then((r) => r.json())
      .then((json) => {
        if (isMounted) setCompany(json as CompanyInfo);
      })
      .catch(() => {
        if (isMounted) setCompany(null);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return company;
};

export { useCompany };
export default useCompany;
